import { render } from "./quote-details-page.vue?vue&type=template&id=70e104a4"
import script from "./quote-details-page.vue?vue&type=script&lang=js"
export * from "./quote-details-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__